module.exports = __webpack_public_path__ + "img/icon-warning.b62c5901.svg";